// Sign-in. Entra (MSAL, the medrec console's pattern) when VITE_AUTH_MODE=entra; local development otherwise (the API refuses local
// mode off 127.0.0.1). The Entra app registration does not exist yet (gated: spec section 7), so the MSAL settings come from build env.
import { PublicClientApplication, type AccountInfo } from '@azure/msal-browser';

const MODE = (import.meta.env.VITE_AUTH_MODE as string | undefined) ?? 'local';
let msal: PublicClientApplication | null = null;
let account: AccountInfo | null = null;
const scope = import.meta.env.VITE_API_SCOPE as string | undefined;

export type AuthState = { kind: 'ready' } | { kind: 'redirecting' } | { kind: 'error'; message: string };

export async function initAuth(): Promise<AuthState> {
  if (MODE !== 'entra') return { kind: 'ready' };
  const clientId = import.meta.env.VITE_ENTRA_CLIENT_ID as string | undefined;
  const tenant = import.meta.env.VITE_ENTRA_TENANT_ID as string | undefined;
  if (!clientId || !tenant || !scope) return { kind: 'error', message: 'Sign-in is not set up for this console yet.' };
  msal = new PublicClientApplication({ auth: { clientId, authority: `https://login.microsoftonline.com/${tenant}`, redirectUri: window.location.origin },
    cache: { cacheLocation: 'sessionStorage' } });
  await msal.initialize();
  const res = await msal.handleRedirectPromise();
  account = res?.account ?? msal.getAllAccounts()[0] ?? null;
  if (!account) { await msal.loginRedirect({ scopes: [scope] }); return { kind: 'redirecting' }; }
  return { kind: 'ready' };
}

export async function getToken(): Promise<string | null> {
  if (!msal || !account || !scope) return null;
  const r = await msal.acquireTokenSilent({ account, scopes: [scope] }).catch(async () => { await msal!.acquireTokenRedirect({ scopes: [scope] }); return null; });
  return r?.accessToken ?? null;
}
